export function isDocumentPageRasterPath(path: string): boolean {
  return /^contentManagement\/documents\/[^/]+\/pages\/\d+$/.test(path.replace(/^\/api\//, ''));
}
